/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuth2TokenRequest
 */
export interface OAuth2TokenRequest {
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    redirectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    refreshToken?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2TokenRequest
     */
    grantType: string;
}

/**
 * Check if a given object implements the OAuth2TokenRequest interface.
 */
export function instanceOfOAuth2TokenRequest(value: object): value is OAuth2TokenRequest {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    if (!('grantType' in value) || value['grantType'] === undefined) return false;
    return true;
}

export function OAuth2TokenRequestFromJSON(json: any): OAuth2TokenRequest {
    return OAuth2TokenRequestFromJSONTyped(json, false);
}

export function OAuth2TokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuth2TokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirect_url'] == null ? undefined : json['redirect_url'],
        'code': json['code'] == null ? undefined : json['code'],
        'refreshToken': json['refresh_token'] == null ? undefined : json['refresh_token'],
        'clientId': json['client_id'],
        'clientSecret': json['client_secret'],
        'grantType': json['grant_type'],
    };
}

export function OAuth2TokenRequestToJSON(json: any): OAuth2TokenRequest {
    return OAuth2TokenRequestToJSONTyped(json, false);
}

export function OAuth2TokenRequestToJSONTyped(value?: OAuth2TokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirect_url': value['redirectUrl'],
        'code': value['code'],
        'refresh_token': value['refreshToken'],
        'client_id': value['clientId'],
        'client_secret': value['clientSecret'],
        'grant_type': value['grantType'],
    };
}

